import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// @ts-ignore
import s from './form.css';
import MysketchPicker from '../../../components/MysketchPicker/MysketchPicker';
import Table from '../Table/Table';
import Collapse, { Panel } from '../../../components/Collapse/Collapse';


const createListItem = (list) => {

  let dataListItem = {}
  list.forEach(element => {
    dataListItem[element.value] = ''
  });

  return dataListItem
}

class IndustryContent extends Component {
  constructor (props) {
    super(props);
    this.dataRef = null

    this.state = {
      colorEditIndex: null,
      editIndex: null,
      itemId: null,
      itemColor: '',
      itemName: '',
      name: '',
      dataListItem: createListItem(props.color),
      axis: 'horizontal',
      errorStatus: {
        state: false,
        msg: ''
      }
    }

  }
  
  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.list !== this.props.list) {
  //     const dataDom = this.dataRef
  //     dataDom.value = this.getTextArea(nextProps.list)
  //   }

  // }


  setError = (state, msg) => {
    this.setState({
      errorStatus: {
        state, msg
      }
    })
  }
  handleChange = (type, e) => {
    const val = typeof e === 'string' ? e : e.target.value 
    this.setState({
      [type]: val
    })
  }

  axisChange (e) {
    let { onChange } = this.props;
    const val = e.target.value
    this.handleChange('axix', val)
    onChange({}, {
      axis: val
    });
  }

  /**
   * 删除颜色
   * @param {Number} index 
   */
  deleteItem (index) {
    let { onChange, list } = this.props;
    list.splice(index, 1)
    onChange({}, list);

  }

  /**
   * 添加/修改颜色
   *
   * @memberof IndustryContent
   */
  addColorItem = () => {
    let { onChange, color } = this.props;
    const { itemColor, itemName, colorEditIndex, itemId } = this.state
    if (typeof colorEditIndex === 'number') {
      color[colorEditIndex] = {
        name: itemName,
        color: itemColor,
        value: itemId
      }
    } else {
      color.push({
        name: itemName,
        value: 'itemId' + (+new Date()),
        color: itemColor
      })
    }

    this.setState({
      colorEditIndex: null,
      itemColor: '',
      itemName: '',
      itemId: ''
    })

    onChange({}, {colorList: color});
  }

  handleClick = () => {
    const { onChange, list, color } = this.props;
    const { editIndex, name, dataListItem } = this.state;
    this.setError(false,'')
    if (!name) {
      return this.setError(true,'请输入品牌')
    }
    if (!dataListItem.agreeable) {return this.setError(true, '请输入顺意群体')}
    if (!dataListItem.neutrality) {return this.setError(true, '请输入中立群体')}
    if (!dataListItem.reverse) {return this.setError(true, '请输入逆意群体')}
    if (isNaN(parseInt(dataListItem.agreeable))) {return this.setError(true, '请输入数值')}
    if (isNaN(parseInt(dataListItem.neutrality))) {return this.setError(true, '请输入数值')}
    if (isNaN(parseInt(dataListItem.reverse))) {return this.setError(true, '请输入数值')}
    if (typeof editIndex === 'number') {
      list[editIndex] = { ...dataListItem, name }
    } else {
      list.push({...dataListItem, name})
    }
    this.setState({editIndex: null,dataListItem: createListItem(color), name: ''})
    onChange({}, list);
  }

  renderColorCake = (color) => {
    const style = {
      display: 'inline-block',
      height: 20,
      width: 20,
      background: color,
      verticalAlign: 'middle'
    }
    return <span style={style}></span>
  }

  colorRemove = (index) => {
    const {color, onChange, list} = this.props;
    color.splice(index, 1)
    onChange({}, {colorList: color});
    
    const colorMap = color.map(item => item.value)

    const newList = []
    list.forEach(item => {
      let obj = {name: item.name}
      colorMap.forEach(ele => {
        obj[ele] = item[ele] || 0
      })

      newList.push(obj)
    })
    onChange({}, newList);
  }

  colorEdit = (index) => {
    const {color} = this.props;
    const item = color[index]
    this.setState({
      colorEditIndex: index,
      itemName: item.name,
      itemColor: item.color,
      itemId: item.value
    })
  }


  remove = (index) => {
    const {list, onChange} = this.props;
    list.splice(index, 1)
    onChange({}, list);
  }

  edit = (index) => {
    const {list} = this.props;
    const item = list[index]
    this.setState({
      editIndex: index,
      name: item.name,
      dataListItem: {...item}
    })
  }

  clear = () => {
    const { onChange } = this.props;
    onChange({}, []);
  }

  onChangeColors = (index, key, value) => {
    let { onChange, color } = this.props;
    const item = color[index]

    color[index] = {
      ...item,
      [key]: value
    }

    onChange([], {
      colorList: color
    })
  }

  onChangeListItem = (key, val) => {
    const {dataListItem} = this.state

    this.setState({
      dataListItem: {
        ...dataListItem,
        [key]: val
      }
    })
  }


    /**
   * 将数组转文本
   * @memberof IndustryContent
   */
  getTextArea = (list) => {
    const result = list.map(item => {
      let result = item.name || ''
      if (item.agreeable !== undefined) {
        result += `\t${item.agreeable}`
      }
      if (item.neutrality !== undefined) {
        result += `\t${item.neutrality}`
      }
      return result
    }).join('\n')
    

    return result
  }

  textareaChange = (e) => {
    const {onChange} = this.props
    const {value} = e.target
    this.setError(false, '')
    const list = value.split('\n').map(item => {
      const itemArr = item.trim().split(/\s+/)
      const [name, agreeable, neutrality] = itemArr
      if (isNaN(parseInt(agreeable)) || isNaN(parseInt(neutrality))) { this.setError(true, '数据格式错误')}
      return {
        name,
        agreeable,
        neutrality
      }
    })

    onChange({}, list);
  }

  render () {
    const {list, color, direction} = this.props;
    const {editIndex,colorEditIndex, name, itemColor, itemName, dataListItem, errorStatus} = this.state;

    return (
      <Collapse className={s.collapse}>
        <Panel header="图例">
          <Table 
            header={() =>
              <tr>
                <th>图例标签</th>
                <th>值</th>
                <th style={{width:150}}>操作</th>
              </tr>
            }
            body={() => color.map((item, index) => 
              <tr key={index}>
                <td>{item.name}</td>
                <td>{this.renderColorCake(item.color)}</td>
                <td>
                  <button onClick={() => this.colorEdit(index)}>修改</button>
                  <button onClick={() => this.colorRemove(index)}>删除</button>
                </td>
              </tr>  
            )}
          />

          <div style={{display: 'flex', justifyContent: 'space-between', marginTop: 10}}>
            <input value={itemName} onChange={e=>{this.handleChange('itemName', e.target.value)}} placeholder="标签" />
            <MysketchPicker value={itemColor} onChange={e=>{this.handleChange('itemColor', e)}} />
            <button onClick={this.addColorItem}>{typeof colorEditIndex === 'number' ? '修改' : '添加'}</button>
          </div>

        </Panel>
        <Panel header="条形图方向">
          <select defaultValue={direction || 'horizontal'} onChange={(e) => {this.axisChange(e)}}>
            <option value="horizontal">横向</option>
            <option value="longitudinal">纵向</option>
          </select>
        </Panel>
        <Panel header="数据" expand>
          <div><button onClick={this.clear}>清空数据</button></div>

          {/* <textarea ref={(ref) => this.dataRef = ref} onBlur={this.textareaChange} cols={70} rows={8} /> */}




          <label className={s.label}>
            <span className={s.labelTit}>品牌：</span>
            <input value={name} onChange={e=>{this.handleChange('name', e.target.value)}} />
          </label>

          {color.map((item, index) => (
            <label key={index} className={s.label}>
              <span className={s.labelTit}>{item.name}：</span>
              <input value={dataListItem[item.value]} onChange={e=>{this.onChangeListItem(item.value, e.target.value)}} />
            </label>
          ))}

          {errorStatus.state && <p style={{color: '#f00'}}>{errorStatus.msg}</p>}

          <button onClick={this.handleClick}>{typeof editIndex === 'number' ? '修改' : '添加'}</button>

          <Table 
            header={() =>
              <tr>
                <th>标签</th>
                {color.map(item => <th key={item.value}>{item.name}</th>)}
                <th style={{width:150}}>操作</th>
              </tr>
            }
            body={() => list.map((item, index) => 
              <tr key={index}>
                <td>{item.name}</td>
                {color.map(_item => <td key={_item.value}>{item[_item.value]}</td>)}
                <td>
                  <button onClick={() => this.edit(index)}>修改</button>
                  <button onClick={() => this.remove(index)}>删除</button>
                </td>
              </tr>  
            )}
          />
        </Panel>
      </Collapse>
    )
  }
}



export default withStyles(s)(IndustryContent)


// WEBPACK FOOTER //
// src/routes/customChart/components/IndustryContent.js